/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BillingMethod } from './BillingMethod';
import {
    BillingMethodFromJSON,
    BillingMethodFromJSONTyped,
    BillingMethodToJSON,
} from './BillingMethod';
import type { BillingPeriodSchema } from './BillingPeriodSchema';
import {
    BillingPeriodSchemaFromJSON,
    BillingPeriodSchemaFromJSONTyped,
    BillingPeriodSchemaToJSON,
} from './BillingPeriodSchema';
import type { CustomGroupSchema } from './CustomGroupSchema';
import {
    CustomGroupSchemaFromJSON,
    CustomGroupSchemaFromJSONTyped,
    CustomGroupSchemaToJSON,
} from './CustomGroupSchema';
import type { FeatureTier } from './FeatureTier';
import {
    FeatureTierFromJSON,
    FeatureTierFromJSONTyped,
    FeatureTierToJSON,
} from './FeatureTier';
import type { OrganizationMembershipSchema } from './OrganizationMembershipSchema';
import {
    OrganizationMembershipSchemaFromJSON,
    OrganizationMembershipSchemaFromJSONTyped,
    OrganizationMembershipSchemaToJSON,
} from './OrganizationMembershipSchema';
import type { SubscriptionStatus } from './SubscriptionStatus';
import {
    SubscriptionStatusFromJSON,
    SubscriptionStatusFromJSONTyped,
    SubscriptionStatusToJSON,
} from './SubscriptionStatus';

/**
 * 
 * @export
 * @interface OrganizationSchema
 */
export interface OrganizationSchema {
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    id: number;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationSchema
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationSchema
     */
    updated: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSchema
     */
    name: string;
    /**
     * 
     * @type {Array<OrganizationMembershipSchema>}
     * @memberof OrganizationSchema
     */
    memberSet: Array<OrganizationMembershipSchema>;
    /**
     * 
     * @type {Array<CustomGroupSchema>}
     * @memberof OrganizationSchema
     */
    customGroups: Array<CustomGroupSchema>;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSchema
     */
    isPersonal: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    memberLimit: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    workspaceLimit: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSchema
     */
    canUseCustomNetworking: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSchema
     */
    canUsePrivatePypi?: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    seatLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    spotUsageLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    armUsageLimit?: number;
    /**
     * 
     * @type {FeatureTier}
     * @memberof OrganizationSchema
     */
    featureTier: FeatureTier;
    /**
     * 
     * @type {BillingMethod}
     * @memberof OrganizationSchema
     */
    billingMethod: BillingMethod;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    activeProgramId?: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    coiledCreditValue: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    creditAllotment: number;
    /**
     * 
     * @type {Array<BillingPeriodSchema>}
     * @memberof OrganizationSchema
     */
    billingPeriods?: Array<BillingPeriodSchema>;
    /**
     * 
     * @type {SubscriptionStatus}
     * @memberof OrganizationSchema
     */
    subscriptionStatus?: SubscriptionStatus;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationSchema
     */
    renewDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationSchema
     */
    trialExpiration?: Date;
    /**
     * 
     * @type {FeatureTier}
     * @memberof OrganizationSchema
     */
    nextPhaseTier?: FeatureTier;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationSchema
     */
    cancelAt?: Date;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    creditLimit: number;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationSchema
     */
    spendLimitShouldStopInstances: boolean;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSchema
     */
    dollarsSpendLimit: number;
}

/**
 * Check if a given object implements the OrganizationSchema interface.
 */
export function instanceOfOrganizationSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "updated" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "memberSet" in value;
    isInstance = isInstance && "customGroups" in value;
    isInstance = isInstance && "isPersonal" in value;
    isInstance = isInstance && "memberLimit" in value;
    isInstance = isInstance && "workspaceLimit" in value;
    isInstance = isInstance && "canUseCustomNetworking" in value;
    isInstance = isInstance && "featureTier" in value;
    isInstance = isInstance && "billingMethod" in value;
    isInstance = isInstance && "coiledCreditValue" in value;
    isInstance = isInstance && "creditAllotment" in value;
    isInstance = isInstance && "renewDate" in value;
    isInstance = isInstance && "creditLimit" in value;
    isInstance = isInstance && "spendLimitShouldStopInstances" in value;
    isInstance = isInstance && "dollarsSpendLimit" in value;

    return isInstance;
}

export function OrganizationSchemaFromJSON(json: any): OrganizationSchema {
    return OrganizationSchemaFromJSONTyped(json, false);
}

export function OrganizationSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
        'name': json['name'],
        'memberSet': ((json['member_set'] as Array<any>).map(OrganizationMembershipSchemaFromJSON)),
        'customGroups': ((json['custom_groups'] as Array<any>).map(CustomGroupSchemaFromJSON)),
        'isPersonal': json['is_personal'],
        'memberLimit': json['member_limit'],
        'workspaceLimit': json['workspace_limit'],
        'canUseCustomNetworking': json['can_use_custom_networking'],
        'canUsePrivatePypi': !exists(json, 'can_use_private_pypi') ? undefined : json['can_use_private_pypi'],
        'seatLimit': !exists(json, 'seat_limit') ? undefined : json['seat_limit'],
        'spotUsageLimit': !exists(json, 'spot_usage_limit') ? undefined : json['spot_usage_limit'],
        'armUsageLimit': !exists(json, 'arm_usage_limit') ? undefined : json['arm_usage_limit'],
        'featureTier': FeatureTierFromJSON(json['feature_tier']),
        'billingMethod': BillingMethodFromJSON(json['billing_method']),
        'activeProgramId': !exists(json, 'active_program_id') ? undefined : json['active_program_id'],
        'coiledCreditValue': json['coiled_credit_value'],
        'creditAllotment': json['credit_allotment'],
        'billingPeriods': !exists(json, 'billing_periods') ? undefined : ((json['billing_periods'] as Array<any>).map(BillingPeriodSchemaFromJSON)),
        'subscriptionStatus': !exists(json, 'subscription_status') ? undefined : SubscriptionStatusFromJSON(json['subscription_status']),
        'renewDate': (new Date(json['renew_date'])),
        'trialExpiration': !exists(json, 'trial_expiration') ? undefined : (new Date(json['trial_expiration'])),
        'nextPhaseTier': !exists(json, 'next_phase_tier') ? undefined : FeatureTierFromJSON(json['next_phase_tier']),
        'cancelAt': !exists(json, 'cancel_at') ? undefined : (new Date(json['cancel_at'])),
        'creditLimit': json['credit_limit'],
        'spendLimitShouldStopInstances': json['spend_limit_should_stop_instances'],
        'dollarsSpendLimit': json['dollars_spend_limit'],
    };
}

export function OrganizationSchemaToJSON(value?: OrganizationSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'created': (value.created.toISOString()),
        'updated': (value.updated.toISOString()),
        'name': value.name,
        'member_set': ((value.memberSet as Array<any>).map(OrganizationMembershipSchemaToJSON)),
        'custom_groups': ((value.customGroups as Array<any>).map(CustomGroupSchemaToJSON)),
        'is_personal': value.isPersonal,
        'member_limit': value.memberLimit,
        'workspace_limit': value.workspaceLimit,
        'can_use_custom_networking': value.canUseCustomNetworking,
        'can_use_private_pypi': value.canUsePrivatePypi,
        'seat_limit': value.seatLimit,
        'spot_usage_limit': value.spotUsageLimit,
        'arm_usage_limit': value.armUsageLimit,
        'feature_tier': FeatureTierToJSON(value.featureTier),
        'billing_method': BillingMethodToJSON(value.billingMethod),
        'active_program_id': value.activeProgramId,
        'coiled_credit_value': value.coiledCreditValue,
        'credit_allotment': value.creditAllotment,
        'billing_periods': value.billingPeriods === undefined ? undefined : ((value.billingPeriods as Array<any>).map(BillingPeriodSchemaToJSON)),
        'subscription_status': SubscriptionStatusToJSON(value.subscriptionStatus),
        'renew_date': (value.renewDate.toISOString()),
        'trial_expiration': value.trialExpiration === undefined ? undefined : (value.trialExpiration.toISOString()),
        'next_phase_tier': FeatureTierToJSON(value.nextPhaseTier),
        'cancel_at': value.cancelAt === undefined ? undefined : (value.cancelAt.toISOString()),
        'credit_limit': value.creditLimit,
        'spend_limit_should_stop_instances': value.spendLimitShouldStopInstances,
        'dollars_spend_limit': value.dollarsSpendLimit,
    };
}

